import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { pure } from '@dbk/ui-react-utils';

import MarketValueHeader from '../../../components/common/market-value-header';

import styles from './header.styles';

function Header({
  marketValue,
  currency,
  messages,
  location
  
}) {
  return (
    <div className="scene">
      <View style={styles.root} testID="asset-header">
        <MarketValueHeader
          marketValue={marketValue}
          marketValueUnit={currency}
          dayChangeVisible={false}
          marketLabelText={messages['app.maturities.options.maturityValue']}
          messages={messages}
          location = {location}
        />
      </View>
    </div>
  );
}

Header.propTypes = {
  marketValue: PropTypes.number,
  currency: PropTypes.string,
};

export default pure(Header);
